import React, {useContext, useState} from 'react';
import { withRouter } from 'react-router-dom';
import './styles.css';
import {Disable} from './../typeahead/typeahead';

// const baseRoute = '/eff'
const navMap = {
    FLIGHTLISTOPTIONS: {
        label: 'Flights Search',
        // path: `${baseRoute}/flightlistoptions`,
        path: '/flightlistoptions',
    },
    FLIGHTLIST: {
        label: 'Flights',
        // path: `${baseRoute}/flights`,
        path: '/flights',
    },
    TANKERING: {
        label: 'Tankering',
        // path: `${baseRoute}/tankering`,
        path: '/tankering',
    },
    CLOSURES: {
        label: 'Closures',
        // path: `${baseRoute}/closures`,
        path: '/closures',
    },
    ALTERNATES: {
        label: 'Alternates',
        // path: `${baseRoute}/alternates`,
        path: '/alternates'
    },
    AIRCRAFT: {
        label: 'Aircraft',
        // path: `${baseRoute}/aircraft`,
        path: '/aircraft',
    },
    AIRCRAFTMAP: {
        label: 'Aircraft Map',
        // path: `${baseRoute}/aircraftmap`,
        path: '/aircraftmap',
    },
    PERMITS: {
        label: 'Permits',
        // path: `${baseRoute}/permits`,
        path: '/permits',
    },
    EFB: {
        label: 'EFB',
        // path: `${baseRoute}/efb`,
        path: '/efb',
    },
    "MEL/CDL": {
        label: 'MEL/CDL',
        // path: `${baseRoute}/melcdl`,
        path: '/melcdl'
    },
    "Work Allocation": {
        label: 'Work Allocation',
        // path: `${baseRoute}/melcdl`,
        path: '/workallocation'
    },
    // FlightArchive: {
    //     label: 'FlightArchive',
    //     path:'/flightsearch'
    // }
}

const Navbar = (props) => {
    const { history, tabs, value} = props;
    // const[isDisable, setDisable] = useState("")
    // // console.log(value , "check")
    // if(value == undefined || value == false){     
    //     setDisable("disabled")
    //    // console.log(isDisable, "if")
    // }        
    // const disable = props.value ? "nav-link btn btn-sm" : "disabled nav-link btn btn-sm";
    const items = tabs && tabs.map(tab => navMap.hasOwnProperty(tab) ? <li key={tab}
        className={history.location.pathname === navMap[tab]['path'] ? 'active' : ''}>
        
        <button className='nav-link btn btn-sm' 
            onClick={_ => history.push(navMap[tab]['path'])}>
            {navMap[tab]['label']}</button>
    </li> : null);
    console.log(value )
    return (
        items && items.length > 1 ?
            <nav className='navbar navbar-expand navbar-dark p-0'
                style={{ boxShadow: 'rgba(255, 255, 255, 0.3) 0px 8px 12px' }}>
                <ul className='navbar-nav mr-auto' id="access">
                    {items}
                </ul>
            </nav>
            :
            null
            
    );
}

export default withRouter(Navbar);
export { navMap };